module.exports = __webpack_public_path__ + "static/img/scenery-01.acfa131.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/album/scenery-01.jpg
// module id = 5Ds0
// module chunks = 0